import React from 'react';
import { styled } from '@compiled/react';
import type { LogoProps } from '@atlaskit/logo';
import { token } from '@atlaskit/tokens';

export const IconType = {
	LOGO: 'logo',
	IMAGE: 'image',
} as const;

export type IconType = (typeof IconType)[keyof typeof IconType];

export type Icon =
	| {
			type: typeof IconType.LOGO;
			component: React.FC<LogoProps>;
			props: LogoProps;
	  }
	| {
			type: typeof IconType.IMAGE;
			props: {
				src: string;
				alt: string;
			};
	  };

export const renderIcon = (icon: Icon, smallIcon?: boolean) => {
	if (icon.type === IconType.LOGO) {
		const { component: Component, props } = icon;
		return (
			<Component
				{...props}
				{...(smallIcon && {
					size: 'small',
				})}
			/>
		);
	}
	if (icon.type === IconType.IMAGE) {
		return smallIcon ? <IconImage {...icon.props} /> : <LargeIconImage {...icon.props} />;
	}
	return null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LargeIconImage = styled.img({
	width: token('space.400', '32px'),
	height: token('space.400', '32px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconImage = styled.img({
	width: token('space.250', '20px'),
	height: token('space.250', '20px'),
	padding: token('space.025', '2px'),
});
